import React from 'react'
import { format } from 'date-fns'
import es from 'date-fns/locale/es'
import { useTranslation } from 'react-i18next'

const DeliveryDateLabel = ({
  date,
  label,
  variant,
  className,
  'data-testid': dataTestId,
}) => {
  const { t } = useTranslation()
  if (!date) return null

  let prefix = label
  if (!label && variant === 'delivery') prefix = t('DELIVERY_DATE')
  if (!label && variant === 'pickup') prefix = t('PICKUP_DATE')
  if (!prefix) prefix = ''

  return (
    <p className={className} data-testid={dataTestId}>
      {`${prefix} ${format(new Date(date), "d 'de' MMMM 'de' yyyy", {
        locale: es,
      })}`}
    </p>
  )
}

export default DeliveryDateLabel
